import Utilities from "../Utilities";
import {Modals} from "../Modals";
import {Tables} from "../Tables/Tables";
import {Components} from "../../components";
import {Alerts} from "../Alerts";
import 'jquery-ui/ui/widgets/dialog';
import {FormOnSubmit} from "./FormOnSubmit";
import {FormOnSuccess} from "./FormOnSuccess";
import {FormOnError} from "./FormOnError";

export class Forms {

    /**
     * Attaches AJAX functionality to any form element within the given selector.
     *
     * @param selector
     */
    static ajaxSubmit(selector) {

        $(selector).find('form:not([no-ajax],[wire])').off('submit').on('submit', (e) => {

            e.preventDefault();

            let form = $(e.target),
                that = this,
                message = $(form).data('confirm');

            if(message  !== undefined)
                Utilities.confirmDialog(message, $(form).data('confirm-type'), function () {
                    Forms.submit(form);
                });
            else
                this.submit(form);

        })
    }

    static submit(form, callback) {

        JsLoadingOverlay.show();

        let data = new FormData(form[0]),
            elements = this.getRenderElements(form);

        if(!form.is('[data-silent]'))
            Forms.formLoader(form);

        if (form.is('[data-on-submit]'))
            data = FormOnSubmit[form.data('onSubmit')](form, data);

        //Check whether we have any sortable elements in this form
        if(form.find('[sortable]').length) {
            form.find('[sortable] [data-repeater-item]').each((key, element) => {
                data.set($(':hidden[name*="position"]', element).attr('name'), key);
            })
        }


        //Check whether we have any JS tree elements in this form
        if(form.find('[data-toggle="tree"]').length) {
            form.find('[data-toggle="tree"]').each((key, element) => {
                let selected_ids = $(element).data('jstree').get_selected(false);
                data.append($(element).data('name'), selected_ids);
            });
        }

        //Check whether we have any kilograms inputs
        if(form.find('input[type="kilograms"]:not(:disabled)').length) {
            form.find('input[type="kilograms"]:not(:disabled)').each((key, element) => {
                data.set($(element).attr('name'), data.get($(element).attr('name')).replace('kg', '').replaceAll(',', '').trim());
            });
        }

        //Check whether we have any centimeter inputs
        if(form.find('input[type="centimeter"]:not(:disabled)').length) {
            form.find('input[type="centimeter"]:not(:disabled)').each((key, element) => {
                data.set($(element).attr('name'), data.get($(element).attr('name')).replace('cm', '').replaceAll(',', '').trim());
            });
        }

        //Check whether we have any monetary inputs
        if(form.find('input[type="monetary"]:not(:disabled)').length) {
            form.find('input[type="monetary"]:not(:disabled)').each((key, element) => {
                if(data.has($(element).attr('name')))
                    data.set($(element).attr('name'), data.get($(element).attr('name')).replace('£', '').replaceAll(',', '').trim());
            });
        }

        //Check whether we have any monetary inputs
        if(form.find('input[data-toggle="datepicker"]').length) {
            form.find('input[data-toggle="datepicker"]').each((key, element) => {

                let date = moment($(element).val(), 'DD/MM/YYYY' + ($(element).is('[data-time]') ? 'HH:mm' : ''));
                if(date.isValid())
                    data.set($(element).attr('name'), date.format("YYYY-MM-DD" + ($(element).is('[data-time]') ? ' HH:mm' : '')));

            });
        }

        //Check whether we have any repeater elements in this form
        if(form.find('[data-repeater-list]').length) {
            form.find('[data-repeater-list] [data-repeater-item]:first-child').each((key, element) => {
                $(':input, select', element).each((key, input) => {
                    data.delete($(input).attr('name'));
                });
            });
        }

        //Check if file location has download in url
        if(form.find('.filepond--data [type="hidden"][name*="photo"]').length) {

            form.find('.filepond--data [type="hidden"][name*="photo"]').each((index, element) => {

                if($(element).val().includes('/download/'))
                    data.set(
                        ($(element).attr('name').includes('[]') ? $(element).attr('name').replace('[]', '['+ $(element).index() +']')  : $(element).attr('name')),
                        $(element).val().replace('/download/', ''));
            });
        }

        form.find('.enableOnSubmit').each((key, element) => {
            data.set($(element).attr('name'), $(element).val());
        });

        if(form.is('[data-silent]'))
            data.set('silent', 'true');

        if(form.attr('action') === undefined)
            return;


        axios({
            method: form.attr('method'),
            url: form.attr('action'),
            data: data
        }).then(response => {
            if (typeof callback === "function")
                callback(response);

            if (form.is('[data-on-success]'))
                FormOnSuccess[form.attr('data-on-success')](form, response.data);

            this.handleSuccess(response.data, form, elements);

            JsLoadingOverlay.hide();
        }).catch(error => {
            if (typeof callback === "function")
                callback(error);

            let response = error.response;

            if (form.is('[data-on-error]'))
                FormOnError[form.attr('data-on-error')](form, response.data);

            this.closeFormLoader(form);

            //Clearing out any previous validation errors
            this.clearErrors(form);

            if(response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {

                Object.keys(response.data.errors).forEach(item => {
                    let message = response.data.errors[item][0]

                    const $input = this.findErrorInput(item, form)

                    this.addErrorToField($input, message);
                })
            }

            if (response.status == 422 && response.hasOwnProperty('data') && response.data.hasOwnProperty('error') && !response.data.hasOwnProperty('errors'))
                Alerts.error(response.data.error);

            if (response.status == 500)
                Alerts.error('500 ERROR: '+response.data.message);

            JsLoadingOverlay.hide();
        })
    }

    /**
     * Handles clearing out any previous errors in the given selectors.
     *
     * @param selector
     */
    static clearErrors(selector) {
        $(':input, [data-form-error]',selector).removeClass('is-invalid')
            .siblings('.invalid-feedback').remove().end()
            .end();
    }

    static handleSuccess(response, form, elements) {

        delete window.modalInputChanges;

        //Clearing out any previous validation errors
        if(form !== null)
            this.clearErrors(form);

        //If there is a redirect uri returned from the server and isn't the current location
        if(response.hasOwnProperty('redirect_uri') && response.redirect_uri !== location.href) {

            location.href = response.redirect_uri;

        } else {


            let locationURL = form !== null && form.is('[data-modal-url]') ? form.data('modal-url') : location.href;

            //Showing success alert if comes back from the server
            if(response.session.hasOwnProperty('success'))
                Alerts.success(response['session']['success']);

            if(form !== null && !form.is('[data-silent]')) {
                //Reloading any tables
                Tables.reloadDataTables('body');

                //Closing any open modals
                if(!form.is('[data-modal-url]'))
                    Modals.closeOpenModals();

                //Scrolling to top of page
                if(form.hasClass('no-scroll') === false)
                    window.scrollTo(0, 0);
            }

            this.closeFormLoader(form);

            //As the locations are the same we need to make a call to fetch the updated HTML for this page
            axios.get(locationURL, {
                params: {
                    elements: elements
                }
            }).then(response => {

                if(response.data.hasOwnProperty('html')) {

                    Object.keys(response.data.html).forEach(id => {

                        document.getElementById(id).outerHTML = response.data.html[id];

                        new Components('#' + id, false);
                    })
                }
            })
        }
    }

    /**
     *
     * Handles attaching an error message to a field and showing this field as invalid.
     *
     * @param field
     * @param message
     */
    static addErrorToField(field, message) {
        $(field).addClass('is-invalid')
            .parent()
            .append('<div class="invalid-feedback">' + message + '</div>');
    }

    static getRenderElements(form) {
        let elements = [];

        $(form).find('[name="elements[]"]').each((key, item) => {
            elements.push($(item).val());
        });

        return elements;
    }

    static autoSubmit(selector) {
        $(selector).find(':input.auto-submit, form.auto-submit :input').off('change').on('change', (e) => {
            let form = $(e.target).closest('form');
            form.submit();
        });
    }

    static formLoader(form) {
        let loaderEl = $(form).is('[data-formLoader]') ? $(form).closest($(form).data('formLoader')) :
            ($(form).closest('.modal-content').length ? $(form).closest('.modal-content') : $(form).closest('.card'))

        Utilities.loadingOverlay(loaderEl, !form.is('[data-silent]'));
    }
    static closeFormLoader(form) {
        let loaderEl = $(form).is('[data-formLoader]') ? $(form).closest($(form).data('formLoader')) :
            ($(form).closest('.modal-content').length ? $(form).closest('.modal-content') : $(form).closest('.card'));


        Utilities.removeLoadingOverlay(loaderEl);
    }

    static findErrorInput(item, form) {
        let inputName = "", inputNameIndex;

        let inputNameOnly = item.split(".")[item.split(".").length - 1]

        //Converting dot notation into bracket notation to match the name attribute on inputs
        item.split(".").forEach((part, index) => {

            inputNameIndex = (!isNaN(part) ? part : inputNameIndex)

            inputName += index === 0 ? part : ("[" + part + "]");

        });

        let $input = form.find('[name="' + inputName + '"]').length ? form.find('[name="' + inputName + '"]') : form.find('[name="' + inputName + '[]"]')

        $input = $input.length ? $input : form.find('[data-form-error="'+ inputName +'"]');


        if($input.length == 0) {

            //Mainly used for empty sub nested repeaters
            $input = $($(form.find('[data-form-error="'+ inputNameOnly +'"]')).get(inputNameIndex))

            if($input.length == 0)
                $input = $($('[name*="'+ inputNameOnly +'"]').get(inputNameIndex))

        }

        return $input
    }
}
